import { render, staticRenderFns } from "./financial-setting.vue?vue&type=template&id=454ccb3d&scoped=true"
import script from "./financial-setting.vue?vue&type=script&lang=js"
export * from "./financial-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ccb3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454ccb3d')) {
      api.createRecord('454ccb3d', component.options)
    } else {
      api.reload('454ccb3d', component.options)
    }
    module.hot.accept("./financial-setting.vue?vue&type=template&id=454ccb3d&scoped=true", function () {
      api.rerender('454ccb3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/financial-setting.vue"
export default component.exports